import {
  Grid,
  Stack,
  useTheme,
  FormControlLabel,
  Checkbox,
  Button,
} from "@mui/material";
import React, { useState } from "react";
import CustomeTextarea from "../../utils/CustomeTextarea";
import CustomTextField from "../../utils/CustomTextField";
import useWindowSize from "../../../hooks/useWindowSize";
import { get, useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { ContactFormSchema } from "./shema";
import axios from "axios";
const ContactForm = () => {
  const theme = useTheme();
  const screenWidth = useWindowSize();
  const [loading, setLoading] = useState(false);
  const {
    handleSubmit,
    formState: { errors },
    reset,
    setValue,
    clearErrors,
    getValues,
  } = useForm({
    resolver: zodResolver(ContactFormSchema),
    defaultValues: {
      terms: false,
    },
  });

  const onSubmit = async ({ terms, ...data }) => {
    setLoading(true);
    try {
      await axios.post(
        `${process.env.REACT_APP_API_ESTAGE}/form/contact`,
        data
      );

      reset();
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
      <Stack
        p={{ xs: 2, md: 4 }}
        border={`1px solid ${theme.palette.divider}`}
        borderRadius="10px"
      >
        <Grid container spacing={3}>
          <Grid item xs={screenWidth < 700 ? 12 : 6} md={6} lg={6}>
            <CustomTextField
              label="Nombre"
              disabled={loading}
              id="first-name"
              placeholder="Ingrese su nombre"
              onChange={(e) => {
                setValue("name", e.target.value);
                clearErrors("name");
              }}
              value={getValues("name")}
              isError={errors.name}
              errorMsg={errors.name?.message}
            />
          </Grid>
          <Grid item xs={screenWidth < 700 ? 12 : 6} md={6} lg={6}>
            <CustomTextField
              label="Apellido"
              id="last-name"
              disabled={loading}
              placeholder="Ingrese su apellido"
              onChange={(e) => {
                setValue("lastName", e.target.value);
                clearErrors("lastName");
              }}
              value={getValues("lastName")}
              isError={errors.lastName}
              errorMsg={errors.lastName?.message}
            />
          </Grid>
          <Grid item xs={screenWidth < 700 ? 12 : 6} md={6} lg={6}>
            <CustomTextField
              label="Correo electrónico"
              id="email"
              type="mail"
              disabled={loading}
              placeholder="Ingrese su correo electrónico"
              onChange={(e) => {
                setValue("email", e.target.value);
                clearErrors("email");
              }}
              value={getValues("email")}
              isError={errors.email}
              errorMsg={errors.email?.message}
            />
          </Grid>

          <Grid item xs={screenWidth < 700 ? 12 : 6} md={6} lg={6}>
            <CustomTextField
              label="Teléfono"
              id="phone"
              disabled={loading}
              placeholder="Ingrese su número de teléfono"
              onChange={(e) => {
                setValue("phone", e.target.value);
                clearErrors("phone");
              }}
              value={getValues("phone")}
              isError={errors.phone}
              errorMsg={errors.phone?.message}
            />
          </Grid>

          <Grid item xs={12}>
            <CustomeTextarea
              id="message"
              disabled={loading}
              label="Mensaje"
              placeholder="Ingrese su mensaje aquí..."
              maxRow={6}
              minRow={6}
              onChange={(e) => {
                setValue("message", e.target.value);
                clearErrors("message");
              }}
              value={getValues("message")}
              isError={errors.message}
              errorMsg={errors.message?.message}
            />
          </Grid>
          <Grid item xs={12}>
            <Stack
              direction={{ xs: "column", md: "row" }}
              alignItems={{ xs: "initial", md: "center" }}
              justifyContent="space-between"
              gap={1}
            >
              <FormControlLabel
                sx={{
                  color: errors.terms ? "red" : "text.secondary",
                  userSelect: "none",
                }}
                label="Estoy de acuerdo con los Términos de uso y la Política de privacidad"
                control={
                  <Checkbox
                    disabled={loading}
                    sx={{
                      "&.Mui-checked": { color: "#a95052" },
                      color: errors.terms ? "red" : "",
                    }}
                    checked={getValues("terms")}
                    onChange={(e) => {
                      setValue("terms", e.target.checked);
                      clearErrors("terms");
                    }}
                  />
                }
              />
              <Button
                type="submit"
                disabled={loading}
                variant="contained"
                sx={{
                  backgroundColor: "#a95052",
                  "&:hover": { backgroundColor: "#8c3e47" },
                }}
              >
                Enviar Mensaje
              </Button>
            </Stack>
          </Grid>
        </Grid>
      </Stack>
    </form>
  );
};

export default ContactForm;
